import {observer} from "mobx-react";
import {Area, AreaChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {ChartDataItemType} from "../../../store";
import {useEffect, useState} from "react";
import {TooltipContent} from "./TooltipContent";
import {ShipmentTypeDto} from "../../../api/kpi";

const backlogColor = '#7E57C2'  // Mittleres Violett
const incomeColor = '#1E88E5'   // Klares Azurblau

interface ShippingReceiptExitsLineChartProps {
    chartData: ChartDataItemType[]
    availableTypes: ShipmentTypeDto[]
}

const ShippingReceiptExitsLineChart = observer(function ShippingReceiptExitsLineChart({
                                                                                          chartData,
                                                                                          availableTypes
                                                                                      }: ShippingReceiptExitsLineChartProps) {
    const [data, setData] = useState<ChartDataItemType[]>([])

    useEffect(() => {
        setData(JSON.parse(JSON.stringify(chartData)) as ChartDataItemType[])
    }, [chartData, availableTypes])

    return <>
        <div style={{
            flex: '1',
            height: '20em'
        }}>
            <ResponsiveContainer>
                <AreaChart data={data}>
                    <Area type="linear" dataKey="receipt" name={"Eingänge"} stroke={incomeColor} fill={incomeColor}
                          fillOpacity={0.6}/>
                    <Area type="linear" dataKey="exit" name={"Ausgänge"} stroke={backlogColor} fill={backlogColor}
                          fillOpacity={0.6}/>

                    <XAxis dataKey="date"/>
                    <YAxis/>
                    <Tooltip content={TooltipContent}/>
                    <Legend/>
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </>
})

export {
    ShippingReceiptExitsLineChart
}
